import { Patient } from '@bioliberty/lifemind';
import { Pencil, Trash } from 'lucide-react';
import { useAuthentication } from '../../../auth';
import { Button } from '../../../components/Button';
import { Heading } from '../../../components/Heading';
import { NoCapture } from '../../../components/NoCapture';

export type PatientTopBarProps = {
  patient: Patient;
  setShowEditModal: (show: boolean) => void;
  setShowDeleteModal: (show: boolean) => void;
};

export const PatientTopBar = ({ patient, setShowEditModal, setShowDeleteModal }: PatientTopBarProps) => {
  const currentUser = useAuthentication();

  const clinic = currentUser.subtenants?.find(({ name }) => name === patient.tenantId);

  return (
    <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
      <div className="flex flex-col items-center md:items-start">
        <Heading size="l">
          <NoCapture>{patient?.alias}</NoCapture>
        </Heading>

        <div className="ps-0.5 text-center text-sm md:text-left">
          {clinic && <span>{clinic.label}, </span>}

          {patient.createdAt && <span>Created {new Date(patient.createdAt).toLocaleDateString()}</span>}
        </div>
      </div>

      <div className="flex gap-5">
        <Button variant="primary" icon={Pencil} onClick={() => setShowEditModal(true)}>
          <div className="hidden md:block">Edit Patient</div>
        </Button>
        <Button variant="danger" icon={Trash} onClick={() => setShowDeleteModal(true)}>
          <div className="hidden md:block">Delete Patient</div>
        </Button>
      </div>
    </div>
  );
};
